module.exports = __webpack_public_path__ + "img/login-desc.349511cd.png";